// api list
// dev 环境会将 value 转成 key，在添加代理
export const apiMap = {
    apiXs: 'https://xiaoshuo.wtzw.com',
    apiGw: 'https://api-gw.wtzw.com',
    apiBc: 'https://api-bc.wtzw.com',
    apiCmnt: 'https://api-cmnt.wtzw.com',
};

// 分享配置
export const shareConfig = {
    title: '我在七猫修个仙，中秋揽月赢好礼！',
    desc: '月满七猫，仙途共赴。精美挂件勋章即刻解锁！',
    imageUrl: 'https://cdn.wtzw.com/activity/mid-autumn-reading/share.jpeg',
    link: 'https://app-share.wtzw.com/h5/activity/freereaderMidAutumn/index?full_screen=3',
};
// 分享类型列表
export const shareTypeList = ['weixin', 'friend', 'qq', 'qzone', 'system'];
